import { ResultDataItem } from './item';
import { MostRequestHistoryResultDataWithProblem } from 'src/graphql/generated/graphql';
import styles from './index.module.css';

interface ResultDataProps {
  data: MostRequestHistoryResultDataWithProblem[];
}

export const ResultData = ({ data }: ResultDataProps) => {
  return (
    <div className="w-full">
      <div
        className={styles.tableWrapper}
        style={{
          gridTemplateRows: `repeat(${Math.round(data?.length / 2)}, auto)`,
        }}
      >
        {data.map((item) => (
          <ResultDataItem key={item.name} item={item} />
        ))}
      </div>
    </div>
  );
};
